<template>
  <div>
    <output
      ><pre>{{ output }}</pre></output
    >
    <button type="click" @click="unauth">Unauth</button>
    <button type="click" @click="auth">Auth</button>
  </div>
</template>

<script>
export default {
  name: "AuthTest",
  data: () => ({ output: "" }),
  methods: {
    async unauth() {
      try {
        this.output = await this.axios.get("api/values/5");
      } catch (e) {
        this.output = e;
      }
    },
    async auth() {
      try {
        this.output = await this.axios.get("api/values");
      } catch (e) {
        this.output = e;
      }
    }
  }
};
</script>

<style scoped></style>
